module.exports = __webpack_public_path__ + "img/accessory_item_05.3c367192.svg";